<template>
    <div class="erm_form_wrapper">

        <div class="input-wrapper">
            <p class="form-label" for="name">Category Name *</p>
            <el-input class="erm_input" v-model="categories.name" style="width: 100%"
                placeholder="Please Input Category Name" size="large" />
            <p class="error-message" style="margin: 0px 0px 10px 0px;">{{ name_error }}</p>
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Upload Category Image </p>
            <AppFileUpload :btnTitle="'Upload Image'" v-model:selectedFile="categories.image" />
        </div>

        <div class="input-wrapper">
            <p class="form-label" for="name">Description</p>
            <WpEditor v-model="categories.description" />
        </div><br>

        <div class="input-wrapper" @click="saveCategory()">
            <el-button size="large" type="primary">Save Category</el-button>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import WpEditor from "../../components/WpEditor.vue";
import AppFileUpload from "../../components/AppFileUpload.vue";
export default {
    components: {
        WpEditor,
        AppFileUpload,
    },
    data() {
        return {
            categories: {
                name: "",
                branch_id: "1",
                image: "",
                description: "",
            },
            name_error: "",
            branch_id_error: "",
            rest_api: window.RestaurantMenuMangeData.rest_api,
            nonce: window.RestaurantMenuMangeData.nonce
        };
    },
    props: {
        categories_data: {
            type: Object,
        }
    },
    watch: {
        categories_data: {
            handler: function (val) {
                this.categories = val;
            },
            deep: true
        }
    },

    methods: {
        async saveCategory() {
            this.name_error = "";
            this.branch_id_error = "";
            if (!this.categories.name) {
                this.name_error = "Category name is required";
                return;
            }
            if (!this.categories.branch_id) {
                this.branch_id_error = "Brunch name is required";
                return;
            }
            try {
                const response = await axios.post(`${this.rest_api}/postCategory`, {
                    data: this.categories,
                    name: this.categories.name,
                    branch_id: this.categories.branch_id,
                    image: this.categories.image,
                    description: this.categories.description,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': this.nonce
                    }
                });
                console.log('Category:', response.data);
                this.$emit("updateDataAfterNewAdd", this.categories);
                this.categories = { name: "", brunch_id: "", description: "" };
                this.$notify({
                    title: 'Success',
                    message: response.data,
                    type: 'success',
                    position: 'bottom right',
                });

            } catch (error) {
                console.error('Error fetching category:', error);
            }
        },


    },
    mounted() {
        if (this.categories_data) {
            console.log('Categories:', this.categories_data);
            this.categories = this.categories_data;
        }
    }

};
</script>